


















import { Component, Vue } from 'vue-property-decorator'
import { Message } from 'element-ui'
import { LoginByEmail,LoginByAccount } from '@/api'
import router from '@/router'
import { saveUser } from '@/store/userStore'

@Component({
  components: {},
})
export default class Login extends Vue {
  private param = {
    // dev@163.com
    username: '',
    // 1234567
    password: '',
  }
  private rules = {
    username: [
      {
        required: true,
        message: '请输入用户名',
        trigger: 'blur',
      },
    ],
    password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
  }

  public submitForm() {
    const login = this.$refs.login as HTMLFormElement
    login.validate(async (valid: boolean) => {
      if (valid) {
        const data = await LoginByAccount({
          account: this.param.username,
          password: this.param.password,
        })
        if (data == null) {
          return false
        }
        saveUser(data)
        Message.success('登录成功')
        router.push('/')
      } else {
        Message.error('登录失败')
        return false
      }
    })
  }
}
